export const NUMBER_WITH_OPTIONAL_MAX_TWO_DECIMALS = new RegExp(
  /^\d+(?:\.\d{1,2})?(?:\,\d{1,2})?$/
);
